<panel width="600">
	<form>
		<h1>{{ 'company.domains.request-transfer.headline' | translate }}</h1>
		<section>
			<custom-input [label]="'company.domains.request-transfer.select-product-variant.auth-id' | translate" [(value)]="authId" [required]="true" />
			<h3>{{ 'company.domains.request-transfer.select-variant' | translate }}</h3>
			<new-domain-product-plan-input [domainName]="domain?.name" />
		</section>
		<section>
			<button ghost [ignoreValidation]="true" (click)="close()"><icon type="xmark" />{{ 'company.domains.request-transfer.reject' | translate }}</button>
			<button confirm [active]="canConfirm()" (click)="confirm()"><icon type="paper-plane" /> {{ 'company.domains.request-transfer.confirm' | translate }}</button>
		</section>
	</form>
</panel>
